import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { authGuard } from '../guards/auth/auth.guard';
import { LoginComponent } from './login/login.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: ':id', component: HomeComponent, canActivate: [authGuard] },
  {
    path: ':id/biography',
    loadComponent: () =>
      import('./biography/biography.component').then(
        (c) => c.BiographyComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: ':id/videos',
    loadComponent: () =>
      import('./videos/overview/videos.component').then(
        (c) => c.VideosComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: ':id/videos/:slug',
    loadComponent: () =>
      import('./videos/player/video-player.component').then(
        (c) => c.VideoPlayerComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: ':id/audio',
    loadComponent: () =>
      import('./audio/overview/audio.component').then((c) => c.AudioComponent),
    canActivate: [authGuard],
  },
  {
    path: ':id/audio/:slug',
    loadComponent: () =>
      import('./audio/player/audio-player.component').then(
        (c) => c.AudioPlayerComponent,
      ),
    canActivate: [authGuard],
  },
  {
    path: ':id/matterport',
    loadComponent: () =>
      import('./matterport/matterport.component').then(
        (c) => c.MatterportComponent,
      ),
    canActivate: [authGuard],
  },
  { path: ':id/login', component: LoginComponent },
  { path: ':id/unauthorized', component: UnauthorizedComponent },
  { path: '**', redirectTo: '/' },
];
